export type CalendarMode = 'resourceTimeGridDay' | 'resourceTimeGridWeek';

export type CalendarHiddenDays = {
  1: boolean;
  2: boolean;
  3: boolean;
  4: boolean;
  5: boolean;
  6: boolean;
  0: boolean;
};

export const defaultHiddenDays: CalendarHiddenDays = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  0: true,
};
